import React from "react";
import { ReactElement } from "react";
// Image
//import logoLight from "assets/images/iclicks-high-resolution-logo-white-transparent.png";
//import logoDark from "assets/images/iclicks-high-resolution-logo-transparent.png";

import logoSm from "assets/images/25x25.png";
import logoLight from "assets/images/150X150 CRM trasnparent.png";
import logoDark from "assets/images/150X150 CRM trasnparent.png";

import { Link } from "react-router-dom";

interface Props {
  children: ReactElement;
}
const CoverLayout: React.FC<Props> = (props: Props) => {
  React.useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "bg-cover",
      "bg-auth-pattern",
      "dark:bg-auth-pattern-dark",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "bg-cover",
        "bg-auth-pattern",
        "dark:bg-auth-pattern-dark",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <div className="mb-0 border-none lg:w-[500px] card bg-white/70 shadow-none dark:bg-zink-500/70">
        <div className="!px-10 !py-12 card-body">
          <Link to="/">
            <img src={logoLight} alt="" className="hidden h-[100px] mx-auto dark:block" />
            <img src={logoDark} alt="" className="block h-[100px] mx-auto dark:hidden" />
          </Link>
          {props.children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CoverLayout;
